import Validator from 'validatorjs'
import formatErrors from './formatErrors'
import {convertYearToJalali, matchableDates} from './dateHelper'

export const persianRegex = '/^[^a-zA-Z]*$/'
export const englishRegex = '/^[- _a-zA-Z0-9.\']*$/'

let rules = {
  name: `required|regex:${englishRegex}`,
  name_fa: `required|regex:${persianRegex}`,
  breeder_id: 'numeric',
  breeder: `regex:${englishRegex}|required_without:breeder_id`,
  breeder_fa: `regex:${persianRegex}|required_without:breeder_id`,
  color_id: 'required|integer',
  birth_date: 'required|numeric',
  birth_date_fa: 'required|numeric',
  gender: 'required|in:male,female',
  sire_id: 'required|integer',
  dam_id: 'required|integer',
  death_date: 'numeric',
  death_date_fa: 'numeric',
  photo_ids: 'array',
  avatar_id: 'integer',
  avatar_x: 'numeric',
  avatar_y: 'numeric',
  avatar_w: 'numeric',
  avatar_h: 'numeric'
}

Validator.register('jalaliYearRange', (value, gregorianYear) => {
  return matchableDates(value, gregorianYear)
}, 'سال جلالی با میلادی تطبیق ندارد')

const makeRules = (values) => {
  let born = values.birth_date || 1900
  let thisYear = new Date().getFullYear()
  let death = values.death_date || thisYear
  return {
    ...rules,
    ...{
      birth_date: `required|integer|min:1900|max:${thisYear}`,
      birth_date_fa: `required|integer|min:${convertYearToJalali(1900)}|max:${convertYearToJalali(death)}`,
      death_date: `integer|min:${born}|max:${thisYear}`,
      death_date_fa: `integer|min:${convertYearToJalali(born)}|max:${convertYearToJalali(thisYear)}`
    }
  }
}

export default function validateNewHorse (values) {
  rules = makeRules(values)

  const validator = new Validator(values, rules, {
    required: 'این فیلد الزامی است',
    string: 'متن معتبر نمی‌باشد',
    numeric: 'این فیلد می‌بایست عدد باشد',
    integer: 'این فیلد می بایست عدد باشد',
    max: {
      numeric: 'مقدار این فیلد نباید بیشتر از :max باشد'
    },
    min: {
      numeric: 'مقدار این فیلد نباید کمتر از :min باشد'
    },
    required_if: 'این فیلد الزامی است',
    required_unless: 'این فیلد الزامی است',
    regex: 'فرمت این فیلد صحیح نمی باشد'
  })
  validator.passes()
  return formatErrors(validator.errors.all())
}



// WEBPACK FOOTER //
// ./src/utils/validateNewHorse.js